import { render, staticRenderFns } from "./resource-image-preview.vue?vue&type=template&id=722c2638&"
import script from "./resource-image-preview.vue?vue&type=script&lang=js&"
export * from "./resource-image-preview.vue?vue&type=script&lang=js&"
import style0 from "./resource-image-preview.vue?vue&type=style&index=0&id=722c2638&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports